module.exports = __webpack_public_path__ + "img/dorm-in.c82a3bd9.png";